import * as React from 'react';

function SvgLocationStoreLocatorFilled(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.5 12.196C8.5 8.498 11.41 5.5 15 5.5s6.5 2.998 6.5 6.696c0 3.075-4.493 9.846-6.008 12.042a.594.594 0 01-.984 0C12.993 22.042 8.5 15.271 8.5 12.196zm3.46 0c0-1.73 1.36-3.132 3.04-3.132s3.04 1.402 3.04 3.132c0 1.73-1.36 3.132-3.04 3.132s-3.04-1.402-3.04-3.132z"
        fill="#414B56"
      />
    </svg>
  );
}

export default SvgLocationStoreLocatorFilled;
